export default "__VITE_ASSET__621a799b__"